import React from 'react';
import Preloader from 'components/common/elements/Preloader'
import ReactDelayRender from 'react-delay-render';

// показывать прелоадер только если долго (дольше 300мс) грузится
export default ReactDelayRender({ delay: 300 })(Preloader);
